import { Injectable, inject } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  private router: Router = inject(Router);
  private authService: AuthService = inject(AuthService); // ✅ Inject only AuthService

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    const requiresKiosk = route.data?.['requiresKiosk'] || false;
    const requiresMeister = route.data?.['requiresMeister'] || false;
    const requiresAdmin = route.data?.['requiresAdmin'] || false;
    const requiresDataSteward = route.data?.['requiresDataSteward'] || false;

    if (
      requiresKiosk &&
      !(
        this.authService.isKiosk || // original kiosk role
        this.authService.isSupportEnrollment || // Support.Enrollment
        this.authService.isSupportBookings || // Support.Bookings
        this.authService.isDataSteward // DataSteward
      )
    ) {
      this.router.navigate(['/dashboard']);
      return false;
    }

    if (
      requiresMeister &&
      !(this.authService.isMeister || this.authService.isDataSteward) // ✅ Allow DataSteward to access Meister routes
    ) {
      this.router.navigate(['/dashboard']); // Redirect if user is not a Meister user
      return false;
    }

    if (
      requiresAdmin &&
      !(this.authService.isAdmin || this.authService.isDataSteward)
    ) {
      this.router.navigate(['/dashboard']);
      return false;
    }

    return true; // ✅ User has the required role
  }
}
